import React from 'react';
import PageHeader from '../components/PageHeader';
import Visorpdf from '../components/pdfviewer';
import useDocumentTitle from '../components/useDocumentTitle';
import NavegavilityFile from '../assets/navegabilidad.pdf';

const Navigability = () => {
    useDocumentTitle("Navegabilidad");
    return (
        <div>
            <PageHeader tittle="NAVEGABILIDAD" />

            <div class="py-8 lg:py-16 px-4 mx-auto max-w-screen-md">
                <p class="font-light text-center sm:text-xl">Bienvenido al manual de usuario de la Dirección de Gestión Catastral Multipropósito. Este manual tiene como objetivo ayudar a los usuarios a utilizar nuestra página web de manera eficiente y efectiva para obtener información sobre múltiples aspectos relacionados con la gestión catastral.</p>
            </div>
            <Visorpdf urlpdf={NavegavilityFile} />

        </div>
    );
}

export default Navigability;